// statusTypesMapper.js
export const statusTypes = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  CLOSED: 'CLOSED',
  NEW: 'NEW',
  EXPIRED: 'EXPIRED',
  EXPIRING: 'EXPIRING',
  EVASED_IN_TIMES: 'EVASED_IN_TIMES',
  EVASED_AFTER_EXPIRY: 'EVASED_AFTER_EXPIRY'
}

const statusTypesMapping = (intl) => ({
  [statusTypes.PENDING]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.pending' }),
  [statusTypes.PROCESSING]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.processing' }),
  [statusTypes.CLOSED]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.closed' }),
  [statusTypes.NEW]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.new' }),
  [statusTypes.EXPIRED]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.expired' }),
  [statusTypes.EXPIRING]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.expiring' }),
  [statusTypes.EVASED_IN_TIMES]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.evasedInTimes' }),
  [statusTypes.EVASED_AFTER_EXPIRY]: intl.formatMessage({ id: 't.app.disputeUci.statusTypes.evasedAfterExpiry' })
})

export const mapStatus = (statusType, intl) => {
  const statusTypes = statusTypesMapping(intl)
  return statusTypes[statusType] || ''
}

export const mapSubStatus = (subStatus, parentStatus, intl) => mapStatus(subStatus, intl)

export const statusBadgeStyleMap = {
  NEW: 'success',
  EXPIRING: 'warning',
  EXPIRED: 'fail',
  EVASED_IN_TIMES: 'success',
  EVASED_AFTER_EXPIRY: 'fail'
}
